import { RotateCcw } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";

import { DataTile } from "../Tagging/components/shared/DataTile";
import { VisualizationContainer } from "../Tagging/components/shared/VisualizationContainer";
import { useRecentEventForCurrentMode } from "../Tagging/hooks/useRecentEventForCurrentMode";
import { selectFocusedEvent } from "../Tagging/store/slices/socket/selectors";
import { resetTiles } from "../Tagging/store/slices/tiles";
import {
  setModalState,
  setQuickTileChange,
} from "../Tagging/store/slices/view";
import type { RootState } from "../Tagging/store/store";
import { eventCleaner } from "../Tagging/utils/eventCleaner";
import { queueEventCleaner } from "../Tagging/utils/queueEventCleaner";
import { getTileDisplayLabel } from "../Tagging/utils/tileDisplayLabels";
import { tileUnits } from "../Tagging/utils/tileUnits";

export const SingleTileContainer = () => {
  const dispatch = useDispatch();

  const { isViewingPreviousEvent } = useSelector(
    (state: RootState) => state.socket,
  );
  const focusedEvent = useSelector(selectFocusedEvent);
  const recentEvent = useRecentEventForCurrentMode();
  const singleViewTile = useSelector(
    (state: RootState) => state.tiles.singleViewTile,
  );

  const eventData = isViewingPreviousEvent
    ? queueEventCleaner(focusedEvent)
    : eventCleaner(recentEvent);

  const tile = singleViewTile.tile;
  const data =
    tile.type === "data"
      ? eventData?.find((elem) => elem.title === tile.title)
      : undefined;

  const handleTileClick = () => {
    const placeholder =
      tile.type === "visualization"
        ? tile.visualization || ""
        : tile.title || "";

    dispatch(
      setQuickTileChange({
        tileType: "single",
        label: "Single Tile",
        tileKey: "tile",
        placeholder,
      }),
    );
    dispatch(setModalState({ state: "Tile Quick Change", data: {} }));
  };

  return (
    <div className="relative flex w-full items-center justify-center">
      {tile.hidden && (
        <button
          type="button"
          title="Reset Tile"
          className="absolute -right-3 -top-3 z-10 flex h-6 w-6 cursor-pointer items-center justify-center rounded bg-white hover:bg-[hsla(218,100%,52%,0.05)]"
          onClick={() => dispatch(resetTiles("single"))}
        >
          <RotateCcw size={14} />
        </button>
      )}

      <div className="w-4/5 max-w-[800px]">
        {tile.type === "visualization" && tile.visualization ? (
          <VisualizationContainer
            containerWidth="100%"
            containerHeight="500px"
          />
        ) : (
          <DataTile
            title={
              tile.type === "data" ? getTileDisplayLabel(tile.title) : undefined
            }
            data={data?.value}
            units={
              tile.type === "data" ? tileUnits[tile.title || ""] : undefined
            }
            onClick={handleTileClick}
            hidden={tile.hidden}
            expandToContainer
          />
        )}
      </div>
    </div>
  );
};
